<template>
    <main class="pd-main">
      <div class="main-content">
        <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
        <div class="row" v-else>
          <div class="col-12">
            <div class="card">
                <h4 class="card-title"><strong>ALL EVENTS</strong></h4>
                <div class="card-body">
                  <v-client-table :columns="columns" :data="data" :options="options"> 
                              <div slot="id" slot-scope="props" >{{props.index}}</div>
                              <div slot="date" slot-scope="props" >{{convertDate(props.row.date)}}</div>
                              <div slot="link" slot-scope="props" >{{props.row.event_link}}</div>
                              <div slot="banner" slot-scope="props" class="h-50px">
                                <img class="h-100" :src="props.row.image_url" alt="..." v-if="props.row.image_url">
                                <p v-else>No Banner</p>
                              </div>
                              <div slot="actions" slot-scope="props">
                                <nav class="flexbox fs-16">
                                  <a href="#" @click="delAction(props.row.id)" data-provide="tooltip" data-original-title="Delete">
                                    <span class="btn btn-sm btn-danger icon ion-android-delete"></span>
                                  </a>
                                </nav>
                              </div>
                  </v-client-table>
                </div>
            </div>
          </div>
          <div class="col-lg-6" v-if="!open_form">
              <div class="card">
                <h4 class="card-title"><strong>NEW EVENT</strong></h4>
                <div class="card-body">
                  <div class="py-30 text-center">
                    <div class="pb-10">
                      <h5> Add New Events</h5>
                      <p class="mb-10">Make sure to include descriptions and link to register for the event.</p>
                    </div>
                    <a class="btn btn-sm btn-round btn-primary" href="#" @click="openForm">Add New</a>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-lg-6" v-else>
              <div class="card">
                <h4 class="card-title"><strong>NEW EVENT</strong></h4>
                <div class="card-body">
                    <div class="form-group">
                      <label>Event Title</label>
                      <input class="form-control" type="text" id="title" @blur="$v.title.$touch()" v-model="title">
                      <div v-if="$v.title.$dirty">
                        <div class="custom-error" v-if="!$v.title.required">*Event name is required.</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Event Date</label>
                      <datepicker v-model="date" @selected="selectDate" :full-month-name='true' inputClass="form-control" placeholder="Choose date" ></datepicker>
                    </div>
                    <div class="form-group">
                      <label>Brief Description</label>
                      <textarea id="desc" cols="30" rows='5' class="form-control" @blur="$v.desc.$touch()" v-model="desc" style="resize: none"></textarea>
                      <div v-if="$v.desc.$dirty">
                        <div class="custom-error" v-if="!$v.desc.required">*Event desc is required.</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Event Registration Link</label>
                      <input class="form-control" type="text" id="link" @blur="$v.link.$touch()" v-model="link">
                      <div v-if="$v.link.$dirty">
                        <div class="custom-error" v-if="!$v.link.required">*Event link is required.</div>
                      </div>
                    </div>
                    <div class="form-group file-group">
                      <label>Upload Event Banner</label>
                      <input type="file" ref="image" class="form-control" @change="imageSelected" placeholder="Choose..."/>
                      <div class="custom-error" v-if="no_image">*Event Banner is required.</div>
                    </div>
                    <button class="mb-10 btn btn-sm btn-bold btn-primary" disabled v-if="loading">
                      <circle-spin class="m-0"></circle-spin>
                    </button>
                    <button class="mb-10 btn btn-sm btn-bold btn-primary" v-else :disabled="$v.$invalid" @click="addEvent" type="button">Add Event</button>
                </div>
              </div>
          </div>
        </div>

        <!-- Modal for delete -->
            <modal name="delete-action" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                    <div class="callout callout-error py-10 px-0 mb-0" role="alert">
                        <span class="close mr-10" @click="hideDeleteModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                        <h5>Delete Event</h5>
                        <div class="p-10">
                            <p>Are you sure you want to delete this event?</p>
                            <button class="btn btn-bold btn-sm btn-danger" disabled v-if="load_delete">
                                <circle-spin class="m-0"></circle-spin>
                            </button>
                            <button class="btn btn-bold btn-sm btn-danger" v-else type="button" @click="deleteAction">Delete</button>
                        </div>
                    </div>
                </div> 
            </modal>
    </div>
    </main>
</template>


<script>
import axios from 'axios'
import {
  required
} from "vuelidate/lib/validators";

export default {
    data() {
        return {
          open_form: false,
          firstLoad: true,
          loading: false,
          title: "",
          desc: "",
          link: 'https://',
          date: new Date (),
          image: '',
          no_image: false,
          columns: ["id", "title", "description", "date", "banner","link", 'actions'],
            data: [],
            options: {
              headings: {
                id: "S/N",
                title: "Title",
                description: "Brief Description",
                date: "Date",
                banner: "Event Banner",
                link: "Event Link",
                actions: "Actions"
              },
              sortable: ["title"],
              filterable: ["title"]
            },
            id: null,
            load_delete: false

        }
    },
    validations: {
      title: { required },
      desc: { required },
      link: { required }
    },
    methods: {
      selectDate(en) {
        let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        this.date = en.toLocaleDateString('en-US', options)
        // console.log(this.date)
      },
      convertDate(payload) {
        let adate = new Date(payload)
        let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return this.date = adate.toLocaleDateString('en-US', options)
      },
        openForm() {
            this.open_form = true
        },
        imageSelected(event) {
          this.image = event.target.files[0];
        },
        addEvent() {
          if(this.image == '') {
            this.no_image = true
          }
          else {
            this.no_image = false
            this.loading = true;
            const formData = new FormData();
            formData.append('title', this.title);
            formData.append('description', this.desc);
            formData.append('event_link', this.link);
            formData.append('date', this.date);
            formData.append('image', this.image);
            axios.post('/admin/add?type=event', formData)
            .then(res => {
                // console.log(res)
                this.loading = false;
                this.$notify({
                  group: 'response',
                  type: 'success',
                  title: 'Successfully added new event',
                  duration: 2500
                });
                setTimeout(() => {
                  location.reload()
                }, 3000)
            })
            .catch(err => {
                this.loading = false;
                this.$notify({
                  group: 'response',
                  type: 'error',
                  title:  `${err.response.data.message}`,
                  duration: 5000
                });
            })
          }
            
        },
        delAction(id) {
          this.id = id
          this.$modal.show("delete-action");
        },
        hideDeleteModal(a) {
            a.hide('delete-action')
        },
        deleteAction() {
          this.load_delete = true
                axios.delete(`/admin/delete?type=event&id=${this.id}`)
                .then(res => {
                    this.load_delete = false
                        this.$notify({
                            group: 'response',
                            type: 'success',
                            text: 'Successfully deleted.',
                            duration: 2500,
                        })
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                })
                .catch(err => {
                    this.load_delete= false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
        }
      },
      mounted() {
        axios.get("/admin/list?type=event").then(res => {
          // console.log(res.data.data)
          this.firstLoad = false;
          return (this.data = res.data.data);
        })
        .catch(err => {
            this.firstLoad = false;
            this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
            });
        })
      }
}
</script>
